import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Col, Row, Container, Collapse } from 'reactstrap';
import { ProtectedButton } from '../../Forms';

import ModalHistoryShipping from '../../Modals/ModalHistoryShipping';
import ModalCheckout from '../../Modals/ModalCheckout';
import { getHistoryShipping } from '../../../actions/postalCodeAction';
import { ModalOutOfStock } from '../../Modals';

class CheckoutProcess extends Component{
  constructor(props){
      super(props);
      this.state = {
        cekShipping: false,
        modalShipping: false,
        _openModal: false,
        _openModalAddress: false,
        _collapseShipping: false,
        _collapsePayment: false
      }
      this._checkout = this._checkout.bind(this);
      this.closeModalShipping = this.closeModalShipping.bind(this);
      this.onChooseShipping = this.onChooseShipping.bind(this);
      this.toggleModalCheckout = this.toggleModalCheckout.bind(this);
      this.shippingToggle=this.shippingToggle.bind(this);
      this.paymentToggle=this.paymentToggle.bind(this);
      // this.toggleModalAddress = this.toggleModalAddress.bind(this);
      // this.handleClickAddress = this._handleClickAddress.bind(this);
  }

  componentDidUpdate() {
    const {id} = this.props.dataAuth.userdata
    const shippingHistory = this.props.dataPostalCode.shippingHistory.data.filter(item => item.user_id === id);
    
    if (shippingHistory.status_code ===  200 && this.state.cekShipping) {
      this.setState({
        cekShipping: false,
        // modalShipping: shippingHistory.data.length === 0 ? false : true
      })
      if (shippingHistory.data.length === 0) {
        this.onChooseShipping(null)
      } else {
        this.onChooseShipping(shippingHistory.data[0])
      }
    }
  }

  componentDidMount(){
    this.props.getHistoryShipping();
  }

  closeModalShipping() {
    const { shippingHistory } = this.props.dataPostalCode

      this.setState({
      cekShipping: false,
      // modalShipping: shippingHistory.data.length === 0 ? false : true
    })
    if (shippingHistory.data.length === 0) {
      this.onChooseShipping(null)
    } else {
      this.onChooseShipping(shippingHistory.data[0])
    }
  }

  closeModalShipping() {
    this.setState({
      modalShipping: !this.state.modalShipping
    })
  }

  /*
    execute on componentDidUpdate
  */
  onChooseShipping(latestShipping) {
    const { shippingHistory, provinces } = this.props.dataPostalCode;
    if (latestShipping === null) {
      this.props.history.push({
        pathname:`checkout/payment_confirmation`,
        search:this.props.location.search,
        shipping_selected: ""
      })
    } else {
      let selectedItem = this.state._selectedItem;

      let checkingIdProvince = provinces.data.filter((a, index) => {
        return a.name === latestShipping.province
      })

      let fix_latestShipping = {...latestShipping, id_province: checkingIdProvince[0].id} //HERE
      // this.props.onChooseShipping({...selectedItem, id_province: checkingIdProvince[0].id})

      this.props.history.push({
        pathname:`checkout/payment_confirmation`,
        search:this.props.location.search,
        shipping_selected:fix_latestShipping
      })
    }
  }

  toggleModalCheckout() {
    this.setState({
      _openModal: !this.state._openModal
    })
  }

  _handleModalCheckout() {
    return(
      <ModalCheckout
      /* From old code */
        {...this.props}

        titleModal = "CHECKOUT"
        isOpen = {this.state._openModal}
        onToggle = {this.toggleModalCheckout}
        dataProduct={this.props.product}
        dataSell={this.props.sell}
        dataAuth={this.props.dataAuth.userdata}

        _balanceUser = {this.props._balanceUser}
        _askingPrice = {this.props._askingPrice}
        _shouldRedirect = {this.props._shouldRedirect}
      />
    )
  }
  
  _checkout(){
    this.setState({ cekShipping: true })
    this.props.funcGetHistoryShipping()
  }

  shippingToggle(){
    this.setState({
      _collapseShipping: !this.state._collapseShipping
    })
  }

  paymentToggle(){
    this.setState({
      _collapsePayment: !this.state._collapsePayment
    })
  }


  render(){
    return (
      <div>
        <Row>
          <Col xs={12} className="button-wrapper">
            <ProtectedButton
              userData={this.props.dataAuth.userdata}
              isLogged={this.props.dataAuth.isLogged}
              roleNotAlloweds={['unverified_user']}
              className="btn-green bold"
              color="success"
              size="lg"
              block
              buttonText="Checkout"
              // onClick={this._checkout}
              onClick={this.toggleModalCheckout}
            />
          </Col>
          <div>
            {this._handleModalCheckout()}
            {/* {this._handleModalAddress()} */}
          </div>
          {/* <Col xs="12 button-wrapper">
              <Link
                to="#"
                className="pull-right link-red link"
                onClick={this.props.onCancel}>
                cancel
              </Link>
          </Col> */}
        </Row>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  dataPostalCode: state.dataPostalCode,
  dataAuth : state.dataAuth,
})

const mapDispatchToProps = dispatch => {
  return{
    getHistoryShipping: () =>dispatch(getHistoryShipping())
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(CheckoutProcess);
